export default "__VITE_ASSET__JBTReDX2__"